import styled from "styled-components";

export const Wrapper = styled.div`
    width: ${18 * 64}px;
    height: ${64 * 3}px;
    position: relative;
    margin: auto;
`;
